import { Link } from 'react-router-dom';
import { FaArrowRight, FaCode, FaShieldAlt, FaTools } from 'react-icons/fa';
import VihsMark from '../../components/VihsMark';
import './ComingSoon.css';

export default function ComingSoon({
  allowDevHub = false,
  mode = 'maintenance',
}) {
  const isDevHubPreview = mode === 'devhub';

  return (
    <div className="coming-soon">
      <div className="coming-soon-atmosphere" aria-hidden="true">
        <span className="coming-soon-glow" />
        <span className="coming-soon-grid" />
      </div>

      <div className="coming-soon-shell">
        <div className="coming-soon-brand">
          <span className="coming-soon-mark"><VihsMark /></span>
          <span className="coming-soon-wordmark">Vih&apos;s</span>
        </div>

        <div className="coming-soon-panel">
          <p className="coming-soon-eyebrow">
            {isDevHubPreview ? <FaCode aria-hidden="true" /> : <FaTools aria-hidden="true" />}
            {isDevHubPreview ? 'Prévia do Dev Hub' : 'Manutenção programada'}
          </p>

          <h1 className="coming-soon-title">
            {isDevHubPreview ? (
              <>
                O restante do site ainda está em <em>preparação</em>.
              </>
            ) : (
              <>
                Em breve. Estamos trabalhando para voltar à <em>operação</em>.
              </>
            )}
          </h1>

          <p className="coming-soon-lead">
            {isDevHubPreview
              ? 'Por enquanto, a prévia pública do Vih\'s Dev Hub já está liberada. Explore o produto enquanto finalizamos o restante da plataforma.'
              : 'Nossa equipe está aplicando melhorias na plataforma para entregar uma experiência mais rápida, estável e segura. Retornaremos em instantes.'}
          </p>

          <div className="coming-soon-progress" aria-hidden="true">
            <span />
          </div>

          <div className="coming-soon-footer">
            <p className="coming-soon-note">
              <FaShieldAlt aria-hidden="true" />
              {isDevHubPreview
                ? 'Login e área admin seguem disponíveis para a equipe.'
                : 'Seus dados permanecem seguros durante a manutenção.'}
            </p>

            <div className="coming-soon-actions">
              {allowDevHub && (
                <Link to="/dev-hub" className="coming-soon-action is-secondary">
                  <FaCode aria-hidden="true" />
                  Conhecer o Dev Hub
                </Link>
              )}
              <Link to="/entrar" className="coming-soon-action">
                Acessar conta
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>

        <p className="coming-soon-copyright">
          © {new Date().getFullYear()} Vih&apos;s — Obrigado pela paciência.
        </p>
      </div>
    </div>
  );
}
